export function RecordStatusFilter(records, locale) {
  const statusToColor = {
    all: 'all',
    'Everything is approved': 'green',
    'Waiting for translations from CBG': 'blue',
    'Waiting for review': 'yellow',
    'Fields are missing translation(s)': 'red'
  };

  const statuses = {};

  for (const [status, color] of Object.entries(statusToColor)) {
    statuses[status] = records
      .filter((record) => locale === 'all' || record.translationStatus[locale])
      .filter((record) => color === 'all' || record.translationStatus[locale]?.color === color)
      .filter((record) => status === 'all' || record.translationStatus[locale]);
  }

  return statuses;
}
